<template>
  <section>
    <section class="search-container">
      <!-- <a-row class="tab-text m-t-24">
                <a @click="changeNavTab(null)" :class="carType ? '' : 'active'">全部</a>
                <a @click="changeNavTab(item.id)" :class="item.id == carType ? 'active' : ''" v-for="item in carTypeMap" :key="item.key">{{item.carTypeName}}</a>
            </a-row> -->
      <a-form layout="inline" class="m-t-14">
        <a-form-item label="单位名称">
          <a-input
            class="search-input"
            placeholder="请输入"
            v-model="searchInfo.companyName"
          />
        </a-form-item>
        <a-form-item label="车辆类型">
          <a-select
            class="search-input"
            v-model="searchInfo.carType"
            placeholder="全部"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
              v-for="item in carTypeMap"
              :key="item.key"
              :value="item.id"
              >{{ item.carTypeName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="车牌号码">
          <a-input
            class="search-input"
            placeholder="请输入"
            v-model="searchInfo.carNumber"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="m-r-8" @click="search"
            ><a-icon type="search" />查询</a-button
          >
          <a-button @click="reset"><a-icon type="reload" />重置</a-button>
        </a-form-item>
      </a-form>
      <a-row class="right-action-panel m-t-14">
        <a-button class="item" @click="checkAll">全选</a-button>
        <!-- <a-dropdown class="item">
                    <a-button>批量操作<a-icon type="caret-down" /></a-button>
                    <a-menu slot="overlay">
                        <a-menu-item key="1"> 模板下载 </a-menu-item>
                        <a-menu-item key="2"> 模板导入 </a-menu-item>
                        <a-menu-item key="3" @click="exprotFile('exportCarLogList', {params: searchInfo})"> 信息导出 </a-menu-item>
                    </a-menu>
                </a-dropdown> -->
        <a-popconfirm title="确定批量删除车辆吗?" @confirm="removeByAllCarInfo"
          ><a-button class="item"
            ><a-icon type="delete" />批量删除</a-button
          ></a-popconfirm
        >
        <a-select
          class="item"
          style="width: 120px"
          type="primary"
          placeholder="批量操作"
        >
          <a-select-option value="模板下载" @click="exportModel"
            >模板下载</a-select-option
          >
          <a-select-option value="信息导入" @click="uploadModal = true"
            >信息导入</a-select-option
          >
          <a-select-option
            value="信息导出"
            @click="exprotFile('exportCar', { params: searchInfo })"
            >信息导出</a-select-option
          >
        </a-select>

        <!-- <router-link class="item" to=""> -->
        <router-link class="item" :to="{ path: '/pcms/car/archives/add' }">
          <!-- <a-button type="primary" @click="showCarModal(null)">添加车辆</a-button> -->
          <a-button type="primary">添加车辆</a-button>
        </router-link>
        <a-checkbox
          v-model="searchInfo.carStatus"
          value="1"
          class="item m-t-6"
          @change="queryCarInfoList"
          >显示陌生车辆</a-checkbox
        >
      </a-row>
    </section>

    <a-row
      type="flex"
      :gutter="20"
      class="list-card-container"
      v-if="listMap.length"
    >
      <a-col :span="6" v-for="(item, key) in listMap" :key="key" class="m-t-16">
        <a-checkbox v-model="item.checked" class="list-checkBox"></a-checkbox>
        <a-row class="list-card-bg">
          <a-row type="flex" class="list-wrap">
            <a-col class="list-image">
              <img :src="item.carImageUrl" alt="" />
            </a-col>
            <a-col style="width: calc(100% - 110px)">
              <a-row class="list-item list-title">
                {{ item.carTypeName || "其他" }}
              </a-row>
              <a-row class="list-item">
                <span class="key">所属单位：</span>
                <span class="val">{{ item.companyName }}</span>
              </a-row>
              <a-row class="list-item">
                <span class="key">车牌号码：</span>
                <span class="val">{{ item.carNumber }}</span>
              </a-row>
              <a-row class="list-item">
                <span class="key">司机姓名：</span>
                <span class="val">{{ item.carName }}</span>
              </a-row>
              <a-row class="list-item">
                <span class="key">联系电话：</span>
                <span class="val">{{ item.carBrand }}</span>
              </a-row>
              <a-row class="list-btn-group">
                <router-link
                  :to="{
                    path: '/pcms/car/archives/details',
                    query: { id: item.id },
                  }"
                  ><a-button size="small">查看</a-button></router-link
                >
                <a-dropdown>
                  <a-button size="small"
                    >更多<a-icon type="caret-down"
                  /></a-button>
                  <a-menu slot="overlay">
                    <a-menu-item key="1">
                      <!-- <a @click="showCarModal(item)">编辑</a>  -->
                      <router-link
                        :to="{
                          path: '/pcms/car/archives/edit',
                          query: { id: item.id },
                        }"
                        >编辑</router-link
                      >
                    </a-menu-item>
                    <a-menu-item key="2">
                      <a-popconfirm
                        @confirm="deleteItem(item.id)"
                        title="确定删除该车辆?"
                        >删除</a-popconfirm
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-row>
            </a-col>
          </a-row>
          <a-row
            :class="
              item.carStatus === 0
                ? 'list-status list-status-ok'
                : 'list-status list-status-err'
            "
            >{{ item.carStatus === 0 ? "已登记" : "陌生车辆" }}</a-row
          >
        </a-row>
      </a-col>
    </a-row>
    <empty v-else :height="430" />
    <section class="pagination-container">
      <a-pagination
        size="default"
        :pageSize="pageSize"
        :current="pageNum"
        :total="total"
        :show-total="(total) => `共${total}条`"
        hide-on-single-page
        :showQuickJumper="true"
        :showSizeChanger="false"
        @change="changePageNum"
      />
    </section>

    <!-- 批量导入 -->
    <a-modal
      width="800px"
      height="480px"
      class="modal-container"
      v-model="uploadModal"
      title="模板导入"
      :footer="false"
    >
      <!-- 导入操作 -->
      <div v-if="progress === 1" style="height: 300px">
        <!-- <uploadFile :accept="['.xlsx']" @func="uploadFile" /> -->
        <a-upload-dragger
          name="file"
          :beforeUpload="beforeUploadFiles"
          :fileList="fileList"
          :accept="accept.join(',')"
          @change="uploadFile"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
          <p class="ant-upload-hint" style="text-align: left; padding: 0 100px">
            <a-row
              >注意：1.使用模板导入功能必须使用系统中下载的车辆信息导入模板。</a-row
            >
            <a-row
              >2.导入模板中请管理人员根据模板文件中的实例，添加车辆信息，在进行导入操作。</a-row
            >
            <a-row
              >3.导入车辆信息时，请确认录入的车辆类型，在平台中存在，确保文字一致。</a-row
            >
            <a-row>
              4.模板导入的车辆信息中，不包含车辆照片附件，后续还需要完善车辆信息。
            </a-row>
          </p>
        </a-upload-dragger>
      </div>
      <!-- 进度条展示 -->
      <div v-else-if="progress === 2" style="text-align: center">
        <a-progress :percent="percent" />
        <p class="gray" style="margin-top: 20px">
          导入模板中，请勿关闭弹窗，关闭弹窗不会收到导入结果
        </p>
        <p class="gray point">取消导入</p>
      </div>
      <div v-else style="text-align: center">
        <p v-if="isSuccess" style="margin-top: 30px">
          <img src="@/assets/image/icon/success.png" alt />
        </p>
        <p v-else style="margin-top: 30px">
          <img src="@/assets/image/icon/fail.png" alt />
        </p>
        <p
          style="
            font-weight: 600;
            font-size: 22px;
            color: #666666;
            margin-top: 10px;
          "
        >
          {{ isSuccess ? "模板导入成功" : "模板导入失败" }}
        </p>
      </div>
    </a-modal>

    <!-- modal -->
    <a-modal
      centered
      width="660px"
      class="modal-container"
      :title="carModal.title"
      v-model="carModal.visible"
      :footer="false"
      :destroyOnClose="true"
    >
      <a-form :form="form">
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="所属单位"
        >
          <a-select
            placeholder="请选择"
            v-decorator="[
              'companyId',
              { rules: [{ required: true, message: '请选择所属单位' }] },
            ]"
          >
            <a-select-option
              v-for="(item, key) in companyMap"
              :key="key"
              :value="item.id"
              >{{ item.companyName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="车牌号"
        >
          <a-input
            placeholder="请输入"
            v-decorator="[
              'carNumber',
              {
                rules: [
                  { required: true, message: '车牌号不能为空' },
                  { validator: validator.carNumberReg },
                ],
              },
            ]"
            class="form-input"
          ></a-input>
        </a-form-item>

        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="车辆类型"
        >
          <a-select
            placeholder="请选择"
            v-decorator="[
              'carType',
              { rules: [{ required: true, message: '请选车辆类型' }] },
            ]"
          >
            <a-select-option
              v-for="(item, key) in carTypeMap"
              :key="key"
              :value="item.id"
              >{{ item.carTypeName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="司机姓名"
        >
          <a-input
            placeholder="请输入"
            v-decorator="[
              'carName',
              {
                rules: [
                  { required: false, message: '司机姓名不能为空' },
                  { max: 5, message: '最大输入5个字符' },
                ],
              },
            ]"
            class="form-input"
          ></a-input>
        </a-form-item>
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="联系电话"
        >
          <a-input
            placeholder="请输入"
            v-decorator="[
              'carBrand',
              {
                rules: [
                  { required: false, message: '联系电话不能为空' },
                  { validator: validator.phoneReg },
                ],
              },
            ]"
            class="form-input"
          ></a-input>
        </a-form-item>
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="上传照片"
        >
          <a-row type="flex">
            <a-row class="upload-preview-wrap">
              <a v-if="files.url" class="file-item m-r-10">
                <a-avatar shape="square" :size="100" :src="files.url" />
              </a>
            </a-row>
            <upload
              style="display: inline-block; width: 100px"
              v-decorator="[
                'carImage',
                { rules: [{ required: false, message: '请上传照片' }] },
              ]"
              :node="{ type: 3, text: '上传' }"
              :accept="['.png', '.jpg']"
              @func="uploadImg"
            />
          </a-row>
        </a-form-item>
        <a-row class="form-btn-group">
          <a-button class="btn-save" @click="submit"
            ><a-icon type="save" />保存</a-button
          >
          <a-button class="btn-cancel" @click="carModal.visible = false"
            >取消</a-button
          >
        </a-row>
      </a-form>
    </a-modal>
  </section>
</template>

<script>
import validator from "@/until/validator";
import upload from "@/components/upload";
import empty from "@/components/empty";
import { exprotFile } from "@/until/unit";
export default {
  data() {
    return {
      validator,
      total: 0,
      pageSize: 8,
      pageNum: 1,
      listMap: [],
      carModal: {
        visible: false,
        title: "添加车辆",
      },
      searchInfo: {},
      carId: "",
      companyMap: [],
      carTypeMap: [],
      files: {},
      checkedAll: false,

      uploadDisabled: false,
      visible2: false,
      flag: true,
      datas: {},
      msg: "",
      marBottom: "",
      submited: true,

      uploadModal: false, //打开文件上传弹窗
      progress: 1, //步骤
      percent: 0,
      uploadResult: "success", //文件上传状态
      //文件相关
      file: {},
      fileList: [],
      FileArr: [],
      uploadLoadding: false,
      accept: [".xlsx"],
      isSuccess: false,
    };
  },
  watch: {
    uploadModal: {
      handler(val) {
        if (val == false) this.progress = 1;
      },
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    picServer() {
      return this.$store.state.picServer;
    },
  },
  created() {
    this.queryCarInfoList();
    this.init();
  },
  components: { upload, empty },
  methods: {
    exprotFile,
    init() {
      this.queryCompanyDropDownBox();
      this.queryCarTypeList();
    },
    //单位下拉
    queryCompanyDropDownBox() {
      this.$api.queryCompanyDropDownBox().then((res) => {
        if (res.code === 200) {
          this.companyMap = res.data || [];
        }
      });
    },
    //车辆类型下拉
    queryCarTypeList() {
      this.$api.queryCarTypeList({ size: 100 }).then((res) => {
        if (res.code === 200) {
          this.carTypeMap = res.data || [];
        }
      });
    },
    //搜索重
    showCarModal(list) {
      this.files = {};
      this.carModal.visible = true;
      this.carModal.title = list ? "编辑车辆" : "新增车辆";
      this.carId = list ? list.id : "";
      this.carId && this.backfillForm(list);
    },
    uploadImg(file) {
      this.files = file;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          carImage: file.codeUrl,
        });
      });
    },
    //编辑时回填数据
    backfillForm(list) {
      let formData = {
        carBrand: list.carBrand,
        carName: list.carName,
        carNumber: list.carNumber,
        companyId: list.companyId,
        carType: list.carType,
        carImage: list.carImage ? list.carImage : "",
      };

      this.files.url = list.carImage
        ? list.carImage.includes("http")
          ? list.carImage
          : this.picServer + list.carImage
        : "";

      this.$nextTick(() => {
        this.form.setFieldsValue(formData);
      });
    },
    //查询车辆列表
    queryCarInfoList() {
      let params = { ...this.searchInfo };
      params.current = this.pageNum;
      params.size = this.pageSize;

      params.carStatus = this.searchInfo.carStatus ? "1" : "";
      this.$api.queryCarInfoList(params).then((res) => {
        if (res.code === 200) {
          let listMap = (res.data && res.data.records) || [];
          listMap.forEach((item) => {
            item.checked = false;
            item.carImageUrl = item.carImage
              ? item.carImage.includes("http")
                ? item.carImage
                : this.picServer + item.carImage
              : require("../../../../assets/image/icon/default-image.png");
          });
          this.listMap = listMap;
          this.total = (res.data && res.data.total) || 0;
        }
      });
    },
    reset() {
      this.searchInfo = {};
      this.pageNum = 1;
      this.queryCarInfoList();
    },
    search() {
      this.pageNum = 1;
      this.queryCarInfoList();
    },
    changePageNum(p) {
      this.pageNum = p;
      this.queryCarInfoList();
    },
    checkAll() {
      this.checkedAll = !this.checkedAll;
      let listMap = [...this.listMap];
      listMap.forEach((item) => {
        // item.checked = true
        item.checked = this.checkedAll;
      });
      this.listMap = listMap;
    },
    //新增和编辑提交表单
    submit() {
      this.form.validateFields((err, formData) => {
        if (!err) {
          if (this.carId) {
            formData.id = this.carId;
          }
          let apiName = this.carId ? "updateCarInfo" : "insertCarInfo";
          this.$api[apiName](formData).then((res) => {
            if (res.code === 200) {
              this.carModal.visible = false;
              this.queryCarInfoList();
            }
          });
        }
      });
    },
    //删除
    deleteItem(id) {
      this.$api.deleteCarInfo(id).then((res) => {
        if (res.code === 200) {
          this.queryCarInfoList();
        }
      });
    },
    removeByAllCarInfo() {
      let checkMaps = this.listMap.filter((item) => item.checked);
      if (checkMaps.length === 0) {
        this.$message.warning("请勾选车辆");
        return false;
      }
      this.$api
        .removeByAllCarInfo({ ids: checkMaps.map((item) => item.id).join(",") })
        .then((res) => {
          if (res.code === 200) {
            this.queryCarInfoList();
          }
        });
    },
    //下载模板
    exportModel() {
      this.exprotFile("exportTemplate", {});
    },
    beforeUploadFiles(file) {
      this.file = file;
      return false;
    },
    getErrorMessage() {
      let message = "请上传";
      if (this.accept.length === 1) {
        message += this.accept[0].split(".")[1] + "格式文件";
      } else {
        this.accept.forEach((item) => {
          message += item.split(".")[1] + "、";
        });
        message += "等格式文件";
      }
      return message;
    },
    //文件格式判断
    isAcceptFileType() {
      let fileType = this.file.name
        .substring(this.file.name.lastIndexOf("."))
        .toLocaleLowerCase();
      if (!this.accept.includes(fileType)) {
        this.uploadLoadding = false;
        this.$message.warning(this.getErrorMessage());
        return false;
      }
      return true;
    },
    //上传文件到服务器
    uploadFile() {
      this.progress = 2;
      this.percent = 10;
      //文件格式判断
      let fileType = this.file.name
        .substring(this.file.name.lastIndexOf("."))
        .toLocaleLowerCase();
      if (!this.accept.includes(fileType)) {
        this.uploadLoadding = false;
        this.$message.warning(this.getErrorMessage());
        return false;
      }
      this.percent = 20;
      //文件上传对象
      let formData = new FormData();
      formData.append("file", this.file);
      this.uploadLoadding = true;
      this.$api
        .addCarBatch(formData)
        .then((res) => {
          this.percent = 30;
          if (res.code === 200) {
            this.percent = 100;
            this.progress = 3;

            this.isSuccess = true;
            // let file = res.data || {};
            // file.url = this.picServer + file.codeUrl;

            // // 上传单张文件
            // if (!this.uploadUp) {
            //   this.$emit("func", file);
            // } else {
            //   //上传多张文件
            //   if (this.loadDatas) {
            //     //判断删除后的文件再进行上传
            //     this.FileArr = this.loadDatas;
            //   }
            //   this.FileArr.push(file);
            //   //   this.$emit("func", this.FileArr);
            // }
            this.pageNum = 1;
            this.queryCarInfoList();
          } else {
            this.progress = 3;
            this.isSuccess = false;
          }
          this.uploadLoadding = false;
        })
        .catch(() => {
          this.uploadLoadding = false;
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.upload-preview-wrap {
  display: inline-block;
  width: auto;
  position: relative;
  .file-item {
    display: inline-block;
    background: #ffffff;
  }
}
.list-card-container {
  .list-image {
    width: 110px;
    height: 150px;
    background: rgba(222, 222, 222, 0.2);
    overflow: hidden;
    justify-content: center;
    align-items: center;
    img {
      object-fit: contain;
      width: 100%;
    }
  }
}
</style>